
window.__pt = window.__pt || {};
window.__pt.fn = window.__pt.fn || {};
window.__pt.squeletons = window.__pt.squeletons || {};
window.__pt.ln = window.__pt.ln || {};
window.__pt.settings = window.__pt.settings || {};
window.__pt.settings.select_item =  "select_item";
window.__pt.settings.view_item_list = "view_item_list";
window.__pt.settings.checkout_progress = "checkout_progress";
window.__pt.settings.add_to_cart = "add_to_cart";
window.__pt.settings.purchase = "purchase";
window.__pt.settings.loginEvent = "header.signin";
window.__pt.settings.logoutEvent = "header.logout";
window.__pt.settings.bookerValuesEvent = "setValuesBooker";
window.__pt.settings.bookerValuesEventFlight = "setValuesBooker_Flight";
window.__pt.settings.bookerValuesEventPackage = "setValuesBooker_Package";
window.__pt.settings.bookerSearchEvent = "smallBookerSearch";
window.__pt.settings.bookerChangeEvent = "onBookerChange";
window.__pt.settings.bookerGoToMapNearbyEvent = "goToMapNearby";
window.__pt.settings.IsCheckmobileAndTablet = true;
window.__pt.settings.checkmobileAndTablet = true;
window.__pt.settings.screenSizes = {
    mobile: '500px',
    small: '767px',
    tablet: '960px',
    desktop: '1280px'
}

window.__pt.settings.defaultPaxes = {
    adults: 1,
    children: []
}

window.__pt.settings.defaultHotel = {
    place_name: null,
    place_selected: {},
    checkIn: null,
    checkOut: null,
    paxes_name: "",
    paxes: {
        adults: 2,
        children: [],
        rooms: 1
    }
}

window.__pt.settings.defaultFlight = {
    place_name: null,
    place_selected: {},
    place_name_to: null,
    place_selected_to: {},
    checkIn: null,
    checkOut: null,
    paxes_name: "",
    mode: true, 
    paxes: [{
        adults: 1,
        children: []
    }]
}


window.__pt.settings.defaultPackage = {
    place_name: null,
    place_selected: {},
    place_name_to: null,
    place_selected_to: {},
    checkIn: null,
    checkOut: null,
    paxes_name: "",
    paxes: [{
        adults: 2,
        children: []
    }]
}

window.__pt.settings.bookerHistorySize = 3;
window.__pt.settings.historyStorageParam = 'history_search_hotels_fam';
window.__pt.settings.historyStorageParamFlight = 'history_search_flights';
window.__pt.settings.historyStorageParamPackage = 'history_search_packages';
window.__pt.settings.recentDestinations = 'recent_destinations_fam';
window.__pt.settings.recentDestinationsFlight = 'recent_destinations_flights';
window.__pt.settings.recentDestinationsPackage = 'recent_destinations_packages';
window.__pt.settings.checkoutData = 'pt.checkoutData';
window.__pt.settings.limitDestinations = 4;


window.__pt.squeletons.list = [{}]

window.__pt.squeletons.results = [{}];

window.__pt.fn.mobileAndTabletCheck = function () {
    let check = false;
    if (window.__pt.settings.IsCheckmobileAndTablet) {
        window.__pt.settings.IsCheckmobileAndTablet = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        window.__pt.settings.checkmobileAndTablet = check;
    }
    check = window.__pt.settings.checkmobileAndTablet;
    return check;
};

window.__pt.fn.encodeUrl = function (data) {
    return Object.keys(data).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
    }).join('&')
}

window.__pt.fn.getScript = function (url, options, cb) {
    $.cachedScript(url, options, cb);
}


window.__pt.fn.search = function () {
    var urlParams = new URLSearchParams(location.search);
    var params = Object.fromEntries(urlParams);
    return params;
}

window.__pt.fn.searchUri = function (url) {
    var urlParams = new URLSearchParams(url);
    var params = Object.fromEntries(urlParams);
    return params;
}

window.__pt.fn.findObject = function (list, property, value) {
    var result = null;
    for (var i = 0; i < list.length; i++) {
        if (list[i][property] == value) {
            result = list[i];
            break;
        }
    }
    return result;
};

window.__pt.fn.clone = function (obj) {
    return JSON.parse(JSON.stringify(obj));
};

window.__pt.fn.getCountry = function(){
    return [
        { name: 'Afghanistan', code: 'AF' },
        { name: 'Albania', code: 'AL' },
        { name: 'Algeria', code: 'DZ' },
        { name: 'American Samoa', code: 'AS' },
        { name: 'Andorra', code: 'AD' },
        { name: 'Angola', code: 'AO' },
        { name: 'Anguilla', code: 'AI' },
        { name: 'Antarctica', code: 'AQ' },
        { name: 'Antigua and Barbuda', code: 'AG' },
        { name: 'Argentina', code: 'AR' },
        { name: 'Armenia', code: 'AM' },
        { name: 'Aruba', code: 'AW' },
        { name: 'Australia', code: 'AU' },
        { name: 'Austria', code: 'AT' },
        { name: 'Azerbaijan', code: 'AZ' },
        { name: 'Bahamas', code: 'BS' },
        { name: 'Bahrain', code: 'BH' },
        { name: 'Bangladesh', code: 'BD' },
        { name: 'Barbados', code: 'BB' },
        { name: 'Belarus', code: 'BY' },
        { name: 'Belgium', code: 'BE' },
        { name: 'Belize', code: 'BZ' },
        { name: 'Benin', code: 'BJ' },
        { name: 'Bermuda', code: 'BM' },
        { name: 'Bhutan', code: 'BT' },
        { name: 'Bolivia', code: 'BO' },
        { name: 'Bosnia and Herzegovina', code: 'BA' },
        { name: 'Botswana', code: 'BW' },
        { name: 'Bouvet Island', code: 'BV' },
        { name: 'Brazil', code: 'BR' },
        { name: 'British Indian Ocean Territory', code: 'IO' },
        { name: 'Brunei Darussalam', code: 'BN' },
        { name: 'Bulgaria', code: 'BG' },
        { name: 'Burkina Faso', code: 'BF' },
        { name: 'Burundi', code: 'BI' },
        { name: 'Cambodia', code: 'KH' },
        { name: 'Cameroon', code: 'CM' },
        { name: 'Canada', code: 'CA' },
        { name: 'Cape Verde', code: 'CV' },
        { name: 'Cayman Islands', code: 'KY' },
        { name: 'Central African Republic', code: 'CF' },
        { name: 'Chad', code: 'TD' },
        { name: 'Chile', code: 'CL' },
        { name: 'China', code: 'CN' },
        { name: 'Christmas Island', code: 'CX' },
        { name: 'Cocos (Keeling) Islands', code: 'CC' },
        { name: 'Colombia', code: 'CO' },
        { name: 'Comoros', code: 'KM' },
        { name: 'Congo', code: 'CG' },
        { name: 'Congo, The Democratic Republic of the', code: 'CD' },
        { name: 'Cook Islands', code: 'CK' },
        { name: 'Costa Rica', code: 'CR' },
        { name: 'Cote D"Ivoire', code: 'CI' },
        { name: 'Croatia', code: 'HR' },
        { name: 'Cuba', code: 'CU' },
        { name: 'Cyprus', code: 'CY' },
        { name: 'Czech Republic', code: 'CZ' },
        { name: 'Denmark', code: 'DK' },
        { name: 'Djibouti', code: 'DJ' },
        { name: 'Dominica', code: 'DM' },
        { name: 'Dominican Republic', code: 'DO' },
        { name: 'Ecuador', code: 'EC' },
        { name: 'Egypt', code: 'EG' },
        { name: 'El Salvador', code: 'SV' },
        { name: 'Equatorial Guinea', code: 'GQ' },
        { name: 'Eritrea', code: 'ER' },
        { name: 'Estonia', code: 'EE' },
        { name: 'Ethiopia', code: 'ET' },
        { name: 'Falkland Islands (Malvinas)', code: 'FK' },
        { name: 'Faroe Islands', code: 'FO' },
        { name: 'Fiji', code: 'FJ' },
        { name: 'Finland', code: 'FI' },
        { name: 'France', code: 'FR' },
        { name: 'French Guiana', code: 'GF' },
        { name: 'French Polynesia', code: 'PF' },
        { name: 'French Southern Territories', code: 'TF' },
        { name: 'Gabon', code: 'GA' },
        { name: 'Gambia', code: 'GM' },
        { name: 'Georgia', code: 'GE' },
        { name: 'Germany', code: 'DE' },
        { name: 'Ghana', code: 'GH' },
        { name: 'Gibraltar', code: 'GI' },
        { name: 'Greece', code: 'GR' },
        { name: 'Greenland', code: 'GL' },
        { name: 'Grenada', code: 'GD' },
        { name: 'Guadeloupe', code: 'GP' },
        { name: 'Guam', code: 'GU' },
        { name: 'Guatemala', code: 'GT' },
        { name: 'Guernsey', code: 'GG' },
        { name: 'Guinea', code: 'GN' },
        { name: 'Guinea-Bissau', code: 'GW' },
        { name: 'Guyana', code: 'GY' },
        { name: 'Haiti', code: 'HT' },
        { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
        { name: 'Holy See (Vatican City State)', code: 'VA' },
        { name: 'Honduras', code: 'HN' },
        { name: 'Hong Kong', code: 'HK' },
        { name: 'Hungary', code: 'HU' },
        { name: 'Iceland', code: 'IS' },
        { name: 'India', code: 'IN' },
        { name: 'Indonesia', code: 'ID' },
        { name: 'Iran, Islamic Republic Of', code: 'IR' },
        { name: 'Iraq', code: 'IQ' },
        { name: 'Ireland', code: 'IE' },
        { name: 'Isle of Man', code: 'IM' },
        { name: 'Israel', code: 'IL' },
        { name: 'Italy', code: 'IT' },
        { name: 'Jamaica', code: 'JM' },
        { name: 'Japan', code: 'JP' },
        { name: 'Jersey', code: 'JE' },
        { name: 'Jordan', code: 'JO' },
        { name: 'Kazakhstan', code: 'KZ' },
        { name: 'Kenya', code: 'KE' },
        { name: 'Kiribati', code: 'KI' },
        { name: 'Korea, Democratic People"S Republic of', code: 'KP' },
        { name: 'Korea, Republic of', code: 'KR' },
        { name: 'Kuwait', code: 'KW' },
        { name: 'Kyrgyzstan', code: 'KG' },
        { name: 'Lao People"S Democratic Republic', code: 'LA' },
        { name: 'Latvia', code: 'LV' },
        { name: 'Lebanon', code: 'LB' },
        { name: 'Lesotho', code: 'LS' },
        { name: 'Liberia', code: 'LR' },
        { name: 'Libyan Arab Jamahiriya', code: 'LY' },
        { name: 'Liechtenstein', code: 'LI' },
        { name: 'Lithuania', code: 'LT' },
        { name: 'Luxembourg', code: 'LU' },
        { name: 'Macao', code: 'MO' },
        { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
        { name: 'Madagascar', code: 'MG' },
        { name: 'Malawi', code: 'MW' },
        { name: 'Malaysia', code: 'MY' },
        { name: 'Maldives', code: 'MV' },
        { name: 'Mali', code: 'ML' },
        { name: 'Malta', code: 'MT' },
        { name: 'Marshall Islands', code: 'MH' },
        { name: 'Martinique', code: 'MQ' },
        { name: 'Mauritania', code: 'MR' },
        { name: 'Mauritius', code: 'MU' },
        { name: 'Mayotte', code: 'YT' },
        { name: 'Mexico', code: 'MX' },
        { name: 'Micronesia, Federated States of', code: 'FM' },
        { name: 'Moldova, Republic of', code: 'MD' },
        { name: 'Monaco', code: 'MC' },
        { name: 'Mongolia', code: 'MN' },
        { name: 'Montserrat', code: 'MS' },
        { name: 'Morocco', code: 'MA' },
        { name: 'Mozambique', code: 'MZ' },
        { name: 'Myanmar', code: 'MM' },
        { name: 'Namibia', code: 'NA' },
        { name: 'Nauru', code: 'NR' },
        { name: 'Nepal', code: 'NP' },
        { name: 'Netherlands', code: 'NL' },
        { name: 'Netherlands Antilles', code: 'AN' },
        { name: 'New Caledonia', code: 'NC' },
        { name: 'New Zealand', code: 'NZ' },
        { name: 'Nicaragua', code: 'NI' },
        { name: 'Niger', code: 'NE' },
        { name: 'Nigeria', code: 'NG' },
        { name: 'Niue', code: 'NU' },
        { name: 'Norfolk Island', code: 'NF' },
        { name: 'Northern Mariana Islands', code: 'MP' },
        { name: 'Norway', code: 'NO' },
        { name: 'Oman', code: 'OM' },
        { name: 'Pakistan', code: 'PK' },
        { name: 'Palau', code: 'PW' },
        { name: 'Palestinian Territory, Occupied', code: 'PS' },
        { name: 'Panama', code: 'PA' },
        { name: 'Papua New Guinea', code: 'PG' },
        { name: 'Paraguay', code: 'PY' },
        { name: 'Peru', code: 'PE' },
        { name: 'Philippines', code: 'PH' },
        { name: 'Pitcairn', code: 'PN' },
        { name: 'Poland', code: 'PL' },
        { name: 'Portugal', code: 'PT' },
        { name: 'Puerto Rico', code: 'PR' },
        { name: 'Qatar', code: 'QA' },
        { name: 'Reunion', code: 'RE' },
        { name: 'Romania', code: 'RO' },
        { name: 'Russian Federation', code: 'RU' },
        { name: 'RWANDA', code: 'RW' },
        { name: 'Saint Helena', code: 'SH' },
        { name: 'Saint Kitts and Nevis', code: 'KN' },
        { name: 'Saint Lucia', code: 'LC' },
        { name: 'Saint Pierre and Miquelon', code: 'PM' },
        { name: 'Saint Vincent and the Grenadines', code: 'VC' },
        { name: 'Samoa', code: 'WS' },
        { name: 'San Marino', code: 'SM' },
        { name: 'Sao Tome and Principe', code: 'ST' },
        { name: 'Saudi Arabia', code: 'SA' },
        { name: 'Senegal', code: 'SN' },
        { name: 'Serbia and Montenegro', code: 'CS' },
        { name: 'Seychelles', code: 'SC' },
        { name: 'Sierra Leone', code: 'SL' },
        { name: 'Singapore', code: 'SG' },
        { name: 'Slovakia', code: 'SK' },
        { name: 'Slovenia', code: 'SI' },
        { name: 'Solomon Islands', code: 'SB' },
        { name: 'Somalia', code: 'SO' },
        { name: 'South Africa', code: 'ZA' },
        { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
        { name: 'Spain', code: 'ES' },
        { name: 'Sri Lanka', code: 'LK' },
        { name: 'Sudan', code: 'SD' },
        { name: 'Suriname', code: 'SR' },
        { name: 'Svalbard and Jan Mayen', code: 'SJ' },
        { name: 'Swaziland', code: 'SZ' },
        { name: 'Sweden', code: 'SE' },
        { name: 'Switzerland', code: 'CH' },
        { name: 'Syrian Arab Republic', code: 'SY' },
        { name: 'Taiwan, Province of China', code: 'TW' },
        { name: 'Tajikistan', code: 'TJ' },
        { name: 'Tanzania, United Republic of', code: 'TZ' },
        { name: 'Thailand', code: 'TH' },
        { name: 'Timor-Leste', code: 'TL' },
        { name: 'Togo', code: 'TG' },
        { name: 'Tokelau', code: 'TK' },
        { name: 'Tonga', code: 'TO' },
        { name: 'Trinidad and Tobago', code: 'TT' },
        { name: 'Tunisia', code: 'TN' },
        { name: 'Turkey', code: 'TR' },
        { name: 'Turkmenistan', code: 'TM' },
        { name: 'Turks and Caicos Islands', code: 'TC' },
        { name: 'Tuvalu', code: 'TV' },
        { name: 'Uganda', code: 'UG' },
        { name: 'Ukraine', code: 'UA' },
        { name: 'United Arab Emirates', code: 'AE' },
        { name: 'United Kingdom', code: 'GB' },
        { name: 'United States', code: 'US' },
        { name: 'United States Minor Outlying Islands', code: 'UM' },
        { name: 'Uruguay', code: 'UY' },
        { name: 'Uzbekistan', code: 'UZ' },
        { name: 'Vanuatu', code: 'VU' },
        { name: 'Venezuela', code: 'VE' },
        { name: 'Viet Nam', code: 'VN' },
        { name: 'Virgin Islands, British', code: 'VG' },
        { name: 'Virgin Islands, U.S.', code: 'VI' },
        { name: 'Wallis and Futuna', code: 'WF' },
        { name: 'Western Sahara', code: 'EH' },
        { name: 'Yemen', code: 'YE' },
        { name: 'Zambia', code: 'ZM' },
        { name: 'Zimbabwe', code: 'ZW' }
    ];
}

window.__pt.fn.getDate = function (dateString) {
    if (!dateString) {
        return new Date();
    }

    if (typeof dateString === 'object') {
        return dateString;
    }

    if (dateString.indexOf("T") > 0 && dateString.indexOf("Z") > 0) {
        return new Date(dateString);
    }

    var stringDate = dateString.replace(/-/g, '/');
    var date = new Date(stringDate.replace(/\.\d/g, ""));
    return date;
}

window.__pt.fn.formatDate = function (date, format, utc) {
    var MMMM = ["\x00", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var MMM = ["\x01", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var dddd = ["\x02", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var ddd = ["\x03", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    function ii(i, len) {
        var s = i + "";
        len = len || 2;
        while (s.length < len) s = "0" + s;
        return s;
    }

    var y = utc ? date.getUTCFullYear() : date.getFullYear();
    format = format.replace(/(^|[^\\])yyyy+/g, "$1" + y);
    format = format.replace(/(^|[^\\])yy/g, "$1" + y.toString().substr(2, 2));
    format = format.replace(/(^|[^\\])y/g, "$1" + y);

    var M = (utc ? date.getUTCMonth() : date.getMonth()) + 1;
    format = format.replace(/(^|[^\\])MMMM+/g, "$1" + MMMM[0]);
    format = format.replace(/(^|[^\\])MMM/g, "$1" + MMM[0]);
    format = format.replace(/(^|[^\\])MM/g, "$1" + ii(M));
    format = format.replace(/(^|[^\\])M/g, "$1" + M);

    var d = utc ? date.getUTCDate() : date.getDate();
    format = format.replace(/(^|[^\\])dddd+/g, "$1" + dddd[0]);
    format = format.replace(/(^|[^\\])ddd/g, "$1" + ddd[0]);
    format = format.replace(/(^|[^\\])dd/g, "$1" + ii(d));
    format = format.replace(/(^|[^\\])d/g, "$1" + d);

    var H = utc ? date.getUTCHours() : date.getHours();
    format = format.replace(/(^|[^\\])HH+/g, "$1" + ii(H));
    format = format.replace(/(^|[^\\])H/g, "$1" + H);

    var h = H > 12 ? H - 12 : H == 0 ? 12 : H;
    format = format.replace(/(^|[^\\])hh+/g, "$1" + ii(h));
    format = format.replace(/(^|[^\\])h/g, "$1" + h);

    var m = utc ? date.getUTCMinutes() : date.getMinutes();
    format = format.replace(/(^|[^\\])mm+/g, "$1" + ii(m));
    format = format.replace(/(^|[^\\])m/g, "$1" + m);

    var s = utc ? date.getUTCSeconds() : date.getSeconds();
    format = format.replace(/(^|[^\\])ss+/g, "$1" + ii(s));
    format = format.replace(/(^|[^\\])s/g, "$1" + s);

    var f = utc ? date.getUTCMilliseconds() : date.getMilliseconds();
    format = format.replace(/(^|[^\\])fff+/g, "$1" + ii(f, 3));
    f = Math.round(f / 10);
    format = format.replace(/(^|[^\\])ff/g, "$1" + ii(f));
    f = Math.round(f / 10);
    format = format.replace(/(^|[^\\])f/g, "$1" + f);

    var T = H < 12 ? "AM" : "PM";
    format = format.replace(/(^|[^\\])TT+/g, "$1" + T);
    format = format.replace(/(^|[^\\])T/g, "$1" + T.charAt(0));

    var t = T.toLowerCase();
    format = format.replace(/(^|[^\\])tt+/g, "$1" + t);
    format = format.replace(/(^|[^\\])t/g, "$1" + t.charAt(0));

    var tz = -date.getTimezoneOffset();
    var K = utc || !tz ? "Z" : tz > 0 ? "+" : "-";
    if (!utc) {
        tz = Math.abs(tz);
        var tzHrs = Math.floor(tz / 60);
        var tzMin = tz % 60;
        K += ii(tzHrs) + ":" + ii(tzMin);
    }
    format = format.replace(/(^|[^\\])K/g, "$1" + K);

    var day = (utc ? date.getUTCDay() : date.getDay()) + 1;
    format = format.replace(new RegExp(dddd[0], "g"), dddd[day]);
    format = format.replace(new RegExp(ddd[0], "g"), ddd[day]);

    format = format.replace(new RegExp(MMMM[0], "g"), MMMM[M]);
    format = format.replace(new RegExp(MMM[0], "g"), MMM[M]);

    format = format.replace(/\\(.)/g, "$1");

    return format;
};




window.__pt.fn.setCookie = function (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
window.__pt.fn.getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

window.__pt.fn.eraseCookie = function (name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}



window.__pt.fn.objectToQueryParams = function (obj) {
    var str = [];

    for (var p in obj) {
        if (obj.hasOwnProperty(p)) {

            var value = obj[p];

            if (value != null && value != undefined) {
                if (p === 'tripMode') {
                    value = value ? 1 : 0;
                }

                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(value));
            }
        }
    }

    return str.join("&");
}

window.__pt.fn.updateQueryParam = function (key, value) {
    
    if (history.pushState) {
        const url = new URL(window.location);
        url.searchParams.set('' + key, value);
        window.history.pushState(null, '', url.toString());
    }
}


window.__pt.fn.mapPaxToUrl = function(paxData) {
    var paxesKeys = {};
    var adults = 0;
    var rooms = 0;
    var children = [];

    if (Array.isArray(paxData)) {
        rooms = paxData.length;
        for (var i = 0; i < paxData.length; i++) {
            adults += (paxData[i].adults || 0);
            if (paxData[i].children) {
                children = children.concat(paxData[i].children);
            }
        }
    } else if (typeof paxData === "object") {
        adults = paxData.adults || 2;
        rooms = paxData.rooms || 1;
        children = paxData.children || [];
    }

    var kids = 0;
    var infants = 0;
    var agekids = [];

    paxesKeys["group_adults"] = adults;
    paxesKeys["no_rooms"] = rooms;

    if (children.length > 0) {
        kids = children.length;
        paxesKeys["group_children"] = kids;
        for (var j = 0; j < children.length; j++) {
            var childYear = children[j].year !== undefined ? children[j].year : children[j];
            agekids.push(childYear);
            if (childYear > 5) {
                kids += 1;
            } else {
                infants += 1;
            }
        }
    }

    if (agekids.length > 0) {
        paxesKeys["age"] = agekids.join(",");
    }
    if (infants > 0) {
        paxesKeys["infant"] = infants;
    }
    return paxesKeys;
};

window.__pt.fn.updateDetailSearchUrl = function(checkIn, checkOut, paxesKeys) {
    if (history.pushState) {
        var url = new URL(window.location.href);
        
        var campaignToken = url.searchParams.get('CampaignToken') || 
                            url.searchParams.get('campaignToken') || 
                            url.searchParams.get('campaignTokenApi') || 
                            url.searchParams.get('CampaignTokenApi') || 
                            url.searchParams.get('campaigntokenapi');
        
        url.search = '';
        
        url.searchParams.set('checkin', checkIn);
        url.searchParams.set('checkout', checkOut);
        
        if (campaignToken) {
            url.searchParams.set('campaignToken', campaignToken);
        }
        
        for (var key in paxesKeys) {
            if (paxesKeys[key] !== undefined && paxesKeys[key] !== null && paxesKeys[key] !== "") {
                url.searchParams.set(key, paxesKeys[key]);
            }
        }
        window.history.pushState({}, '', url.toString());
    }
};

window.__pt.fn.getParamsJson = function () {
    return Object.fromEntries(new URLSearchParams(window.location.search));
}


window.__pt.fn.diffBetweenDays = function(dateStart, dateFinish) {
    const diffTime = Math.abs(dateFinish.getTime() - dateStart.getTime());
    return Math.ceil(diffTime / (86400000));
};


window.__pt.fn.onViewComponent = function (div, callback, options) {
    if ($(div).length == 0) {
        return;
    }
    var triggerAtY = $(div).offset().top - $(window).outerHeight();
    if (triggerAtY < $(window).scrollTop()) {
        callback(options);
        $(div).removeClass("visibility-none")
        return;
    }
    $(window).scroll(function (event) {
        if (triggerAtY > $(window).scrollTop()) {
            return;
        }
        callback(options);
        $(div).removeClass("visibility-none")
        $(this).off(event);
    });
}

window.__pt.fn.countNigths = function (checkIn, checkOut) {
    if (!checkIn || !checkOut)
        return null;

    return Math.ceil((new Date(checkOut).getTime() - new Date(checkIn).getTime()) / (1000 * 3600 * 24));
}

window.__pt.fn.mediaQueries = function (screenSizes) {

    const mediaQueryDesktop = () =>
        window.matchMedia(`(min-width: ${screenSizes.desktop})`);

    const mediaQueryTablet = () =>
        window.matchMedia(`(min-width: ${screenSizes.tablet})`);

    const mediaQuerySmall = () =>
        window.matchMedia(`(min-width: ${screenSizes.small})`);

    const mediaQueryMobile = () =>
        window.matchMedia(`(min-width: ${screenSizes.mobile})`);

    return { mediaQueryDesktop, mediaQueryTablet, mediaQuerySmall, mediaQueryMobile}
}

window.__pt.fn.sleep = function (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

window.__pt.fn.isInViewport = (element, gap = 50) => {

    if ($(element).length == 0) {
        return false;
    }

    const rect = $(element)[0].getBoundingClientRect();

    if (rect.height > (window.innerHeight || document.documentElement.clientHeight)) {
        return (
            rect.top <= gap &&
            rect.bottom > 0
        );

    } else {
        return (
            rect.top >= -gap &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
}


window.addEventListener('popstate', function (event) {
    if (event.isTrusted) {
        window.location.reload();
    }

});


if (window.jQuery) {
    jQuery.cachedScript = function (url, options, callback) {

        var s = document.createElement('script');
        s.setAttribute('src', url);
        s.onload = callback;
        document.body.appendChild(s);

    };


    jQuery.event.special.touchstart = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
    jQuery.event.special.touchmove = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
    jQuery.event.special.wheel = {
        setup: function (_, ns, handle) {
            this.addEventListener("wheel", handle, { passive: true });
        }
    };
    jQuery.event.special.mousewheel = {
        setup: function (_, ns, handle) {
            this.addEventListener("mousewheel", handle, { passive: true });
        }
    };
}

window.__pt.fn.mapPaxToUrlOriginal = (pax, cap, check) => {
    let capitilize = !!cap;
    let checkout = !!check;
    let paxesKeys = {};
    let adults = 0;
    let kids = 0;
    let infants = 0;
    let agekids = [];
    let rooms = pax.length;

    for (let i = 0; i < rooms; i++) {
        const room = pax[i];
        let position = i + 1;

        paxesKeys[`${capitilize ? "R" : "r"}oom${position}.${capitilize ? "A" : "a"}dults`] = room.adults;
        adults += room.adults;

        let childrens = room.children.length;
        let childreJoin = [];
        for (let c = 0; c < childrens; c++) {
            const childrenRoom = room.children[c];
            childreJoin.push(childrenRoom.year);
            agekids.push(childrenRoom.year);
            if (childrenRoom.year > 5) {
                kids += 1;
            } else {
                infants += 1;
            }
        }
        paxesKeys[`${capitilize ? "R" : "r"}oom${position}.${capitilize ? "K" : "k"}ids`] = childrens;
        paxesKeys[`${capitilize ? "R" : "r"}oom${position}.${capitilize ? "A" : "a"}gekids`] = childreJoin.join(",");

    }
    paxesKeys[`${capitilize ? "R" : "r"}ooms`] = rooms;
    paxesKeys[`${capitilize ? "A" : "a"}dults`] = adults;
    paxesKeys[`${capitilize ? "K" : "k"}ids`] = kids;

    if (checkout) {
        paxesKeys[`${capitilize ? "K" : "k"}ids`] = paxesKeys[`${capitilize ? "K" : "k"}ids`] + infants
    } else {
        paxesKeys[`${capitilize ? "I" : "i"}nfants`] = infants;
    }

    paxesKeys[`${capitilize ? "A" : "a"}gekids`] = agekids.join(",");


    return paxesKeys;
}
window.__pt.fn.mapPaxToUrlNew = (pax, cap, check) => {
    let capitilize = !!cap;
        let checkout = !!check;
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let infants = 0;
        let agekids = [];
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];
            let position = i + 1;
            const [adultsStr, childrenStr] = room.split('|');
            const children = childrenStr ? childrenStr.split(',') : [];
            paxesKeys[`${capitilize ? "R" : "r"}oom${position}.${capitilize ? "A" : "a"}dults`] = parseInt(adultsStr) || 0;
            adults += parseInt(adultsStr) || 0;

            let childrens = children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = children[c];
                childreJoin.push(childrenRoom);
                agekids.push(childrenRoom);
                if (childrenRoom > 5) {
                    kids += 1;
                } else {
                    infants += 1;
                }
            }
            paxesKeys[`${capitilize ? "R" : "r"}oom${position}.${capitilize ? "K" : "k"}ids`] = childrens;
            paxesKeys[`${capitilize ? "R" : "r"}oom${position}.${capitilize ? "A" : "a"}gekids`] = childreJoin.join(",");

        }
        paxesKeys[`${capitilize ? "R" : "r"}ooms`] = rooms;
        paxesKeys[`${capitilize ? "A" : "a"}dults`] = adults;
        paxesKeys[`${capitilize ? "K" : "k"}ids`] = kids;

        if (checkout) {
            paxesKeys[`${capitilize ? "K" : "k"}ids`] = paxesKeys[`${capitilize ? "K" : "k"}ids`] + infants
        } else {
            paxesKeys[`${capitilize ? "I" : "i"}nfants`] = infants;
        }

        paxesKeys[`${capitilize ? "A" : "a"}gekids`] = agekids.join(",");


        return paxesKeys;
}
window.__pt.fn.mapPaxToUrl = (paxData) => {
    let paxesKeys = {};
    let adults = paxData.adults;
    let kids = 0;
    let infants = 0;
    let agekids = [];
    paxesKeys['group_adults'] = adults;
    paxesKeys['no_rooms'] = paxData.rooms;
    if (paxData.children && paxData.children.length > 0) {
        kids = paxData.children.length;
        paxesKeys['group_children'] = kids;

        for (const child of paxData.children) {
            agekids.push(child.year);
            if (child.year > 5) {
                kids += 1;
            } else {
                infants += 1;
            }
        }
    }
    if (agekids.length > 0) {
        paxesKeys['age'] = agekids;
    }
    if (infants > 0) {
        paxesKeys['age_infant'] = infants;
    }
    return paxesKeys;
}

window.__pt.fn.generateUUID = () => {
    var d = new Date().getTime();
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}
window.__pt.fn.thresHold = (code) => {
    let threshold;
    if (code === "TB") {
        threshold = 11000;
    } else if (code === "PTES" || code === "PTUS") {
        threshold = 3;
    } else if (code === "PTMX") {
        threshold = 50;
    } else {
        threshold = 50; 
    }
    return threshold;
}

/**
 * Genera un slug uri a partir del nombre del destino.
 * Ej: "Cancún" ? "cancun"
 * @param {object} place - Objeto place con propiedades name y displayText
 * @returns {string} slug uri del destino
 */
window.__pt.fn.buildPlaceUri = function (place) {
    place = place || {};
    const raw = place.name
        || (place.displayText || '').split(',')[0]
        || '';
    return raw
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') 
        .replace(/[^a-z0-9]+/g, '-')     
        .replace(/(^-|-$)/g, '');         
};
window.__pt.fn.captureGclid = function() {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const gclid = urlParams.get('gclid');
        
        if (gclid) {
            window.__pt.fn.setCookie('_gclid', gclid, 10);
        }
    } catch (error) {
        console.error('Error al capturar gclid:', error);
    }
}

window.__pt.fn.syncClientId = function() {
    try {
        const gaValue = window.__pt.fn.getCookie('_ga');
        if (gaValue) {
            window.__pt.fn.setCookie('_client_id', gaValue, 10);
        }
    } catch (error) {
        console.error('Error al sincronizar client_id:', error);
    }
}

window.__pt.fn.captureGclid();
window.__pt.fn.syncClientId();
